const AllMMMProductData = (productData) => {
  const finalProductsData = [];

  Object.keys(productData).forEach((item) => {
    finalProductsData.push(productData[item]);
  });

  return finalProductsData;
};

export const finalMMMHomeProducts = AllMMMProductData(window.home4Products || {});

const AllMMMAdvData = (mmmAdvData) => {
  const finalMMMHomeAdv = {
  };

  const newIndexData = mmmAdvData;

  Object.keys(newIndexData).forEach((item) => {
    finalMMMHomeAdv[item] = newIndexData[item];
  });

  return finalMMMHomeAdv;
};

export const finalMmmHomeAdvData = AllMMMAdvData(window.mmmHomeAdv || {});
export const finalZhMMMSauceAdvData = AllMMMAdvData(window.zhMMMSauceAdv || {});
export const finalZhMMMNoodlesAdvData = AllMMMAdvData(window.zhMMMNoodlesAdv || {});
export const finalZhMMMVideosAdvData = AllMMMAdvData(window.zhMMMVideosAdv || {});
